import { createAction, props } from '@ngrx/store';

export const resetStateAction = createAction(
  `[Common] Reset State Action`,
  props<{
    entity: string;
  }>()
);
